/**
 * @generated SignedSource<<7ac3b6d1f4744702c64037cb4a330760>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type aiArticleListSponsoredArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentItemRenderContent">;
  readonly " $fragmentType": "aiArticleListSponsoredArticle";
};
export type aiArticleListSponsoredArticle$key = {
  readonly " $data"?: aiArticleListSponsoredArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"aiArticleListSponsoredArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "aiArticleListSponsoredArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentItemRenderContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "af30c00c32cc6063bea7ac235d2874da";

export default node;
